// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","713":"component---src-pages-privacy-policy-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"bed5343acb098949d9f0","678":"2be6f8a8ce430cfc941e","713":"fddd6f1aa020c06f23e1","883":"310e14c52a555fc9f9a6"}[chunkId] + ".js";
};